/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_DescriptionInputs */

const en_admin_description = /** @type {(inputs: Admin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System overview`)
};

/**
* | output |
* | --- |
* | "System overview" |
*
* @param {Admin_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_description = /** @type {((inputs?: Admin_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_description(inputs)
});
export { admin_description as "admin.description" }